<template>
  <path
    d="M2.4 16.102A10 10 0 1 1 5.897 19.6h0l-3.455.987a.833.833 0 0 1-1.03-1.03l.986-3.456h0Z"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>